import React from 'react';
import './MoonCodepenReference.css';

export interface MoonPhaseCodepenStaticProps {
  /** Klatka 0–100 — jak freeze-N w moon_freeze_0_100.html */
  perc: number;
  /**
   * Średnica księżyca w px (domyślnie 100 jak w CodePenie).
   * Ustawiaj tutaj zamiast `transform: scale(...)`, żeby zachować ostre krawędzie.
   */
  sizePx?: number;
}

/** Opóźnienia jak w moon_freeze_0_100.html (paused + negative delay). */
export function moonFreezeDelays(perc: number): { disc: string; before: string } {
  const p = Math.max(0, Math.min(100, Math.round(perc)));
  return {
    disc: `${-(p * 0.04)}s`,
    before: `${1 - p * 0.04}s`,
  };
}

/**
 * Ta sama para animacji co referencja CodePen, zatrzymana jak w moon_freeze_0_100.html
 * (paused + animation-delay na .disc i ::before).
 */
const MoonPhaseCodepenStatic: React.FC<MoonPhaseCodepenStaticProps> = ({ perc, sizePx = 100 }) => {
  const p = Math.max(0, Math.min(100, Math.round(perc)));
  const { disc, before } = moonFreezeDelays(p);
  const side = Math.max(16, Math.round(sizePx));

  return (
    <div className="moon-codepen-ref">
      <div
        className={`moon freeze freeze-${p}`}
        role="img"
        style={
          {
            width: side,
            height: side,
            '--freeze-disc-delay': disc,
            '--freeze-before-delay': before,
          } as React.CSSProperties
        }
        aria-label={`Faza Księżyca około ${p}% oświetlenia (widok statyczny)`}
      >
        <div className="disc" aria-hidden />
      </div>
    </div>
  );
};

export default MoonPhaseCodepenStatic;
